"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InitAudioAction = void 0;
var tslib_1 = require("tslib");
var interfaces_1 = require("@dp-instant/interfaces");
var core_1 = require("@dp-instant/core");
var howler_1 = require("howler");
var inversify_1 = require("inversify");
var AudioModel_1 = require("../model/AudioModel");
var core_2 = require("@dp-instant/core");
var InitAudioAction = (function (_super) {
    tslib_1.__extends(InitAudioAction, _super);
    function InitAudioAction() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    InitAudioAction.prototype.execute = function () {
        var _a, _b;
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var audioConfig, cookies, _c, _d, key, howl, bindingId;
            var e_1, _e;
            return tslib_1.__generator(this, function (_f) {
                switch (_f.label) {
                    case 0:
                        audioConfig = this.gameConfig.audio;
                        if (!audioConfig) return [3, 2];
                        return [4, this.cookie.get(AudioModel_1.AudioModel.COOKIE_KEY)];
                    case 1:
                        cookies = _f.sent();
                        try {
                            for (_c = tslib_1.__values(Object.keys(audioConfig)), _d = _c.next(); !_d.done; _d = _c.next()) {
                                key = _d.value;
                                if (audioConfig[key]) {
                                    howl = new howler_1.Howl(this.fixPaths(audioConfig[key]));
                                    bindingId = "howl_".concat(key);
                                    core_1.di.bind(bindingId).toConstantValue(howl);
                                    if (process.env.NODE_ENV === "development") {
                                        window[bindingId] = (0, core_1.lazyGet)(bindingId);
                                    }
                                }
                            }
                        }
                        catch (e_1_1) { e_1 = { error: e_1_1 }; }
                        finally {
                            try {
                                if (_d && !_d.done && (_e = _c.return)) _e.call(_c);
                            }
                            finally { if (e_1) throw e_1.error; }
                        }
                        this.model.init((_a = cookies[AudioModel_1.AudioModel.COOKIE_KEY]) === null || _a === void 0 ? void 0 : _a.sounds, (_b = cookies[AudioModel_1.AudioModel.COOKIE_KEY]) === null || _b === void 0 ? void 0 : _b.music);
                        return [3, 2];
                    case 2: return [2];
                }
            });
        });
    };
    InitAudioAction.prototype.fixPaths = function (options, origin) {
        if (origin === void 0) { origin = core_2.IS_ODR_BUILD ? core_2.ODR_BUILD_ORIGIN : core_1.GAME_SCRIPT_ORIGIN; }
        if (Array.isArray(options.src)) {
            options.src = options.src.map(function (src) { return "".concat(origin).concat(src); });
        }
        else if (typeof options.src === "string") {
            options.src = "".concat(origin).concat(options.src);
        }
        return options;
    };
    tslib_1.__decorate([
        (0, inversify_1.inject)(interfaces_1.TypesCore.gameConfig),
        tslib_1.__metadata("design:type", Object)
    ], InitAudioAction.prototype, "gameConfig", void 0);
    tslib_1.__decorate([
        (0, inversify_1.inject)(interfaces_1.TypesAudio.model),
        tslib_1.__metadata("design:type", AudioModel_1.AudioModel)
    ], InitAudioAction.prototype, "model", void 0);
    tslib_1.__decorate([
        (0, inversify_1.inject)(interfaces_1.TypesSocial.cookie),
        tslib_1.__metadata("design:type", Object)
    ], InitAudioAction.prototype, "cookie", void 0);
    InitAudioAction = tslib_1.__decorate([
        (0, inversify_1.injectable)()
    ], InitAudioAction);
    return InitAudioAction;
}(core_1.Action));
exports.InitAudioAction = InitAudioAction;
//# sourceMappingURL=InitAudioAction.js.map